import { Button, Col, Divider, FlexboxGrid, Input } from 'rsuite';
import { getArrayFilled } from '../../utils/helpers';
import { useCallback, useEffect, useState } from 'react';
import { faIR } from 'date-fns-jalali/locale';
import { format, eachDayOfInterval } from 'date-fns-jalali';
import {
  handleGetSession,
  handlePatchSessionDoneByConsultant,
  handlePostSessionTimeByConsultant,
  handlePutSessionTimeByConsultant,
  handlePutSessionTimeByUser
} from '../../api-handler/consult';
import { useNavigate, useParams } from 'react-router-dom';
import { showToast } from '../../utils/toast';
import { CustomLoader } from '../../components/basic/loader';
import { useUser } from '../../contexts/user';

export const TimeList = (props: {
  day: number;
  isTimeEnabled: (d: number, t: number) => number;
  toggleSelectedTime: (d: number, t: number, e: number) => void;
  daysOfWeek: Date[];
  asConsultant: boolean;
  viewMode: boolean;
}) => {
  return (
    <>
      <div className="flex flex-col w-[100%] xs:w-[50%] sm:w-[33%] md:w-[25%] lg:w-[14%] font-fd">
        <span className="text-center text-h5 mb-3">
          {format(props.daysOfWeek[props.day - 1].toString(), 'EEE dd MMMM', { locale: faIR })}
        </span>
        {/* <span className="text-center text-h5 mb-3">{weekdays[props.day - 1]}</span> */}
        {getArrayFilled(0, 24 - 8).map((timem8) => {
          const time = timem8 + 8;
          const isEnabled = props.isTimeEnabled(props.day, time);
          return (
            <Button
              key={`${props.day}-${time}`}
              className={`!mb-1 mx-2 block ${isEnabled === 1 ? '!bg-[--rs-primary-500] !text-[--rs-gray-50]' : isEnabled === 2 ? '!bg-[--rs-success-500] !text-[--rs-gray-50]' : 'ffff'}`}
              onClick={() => {
                if (props.viewMode) {
                  return;
                } else {
                  props.toggleSelectedTime(props.day, time, isEnabled);
                }
              }}
              disabled={!props.asConsultant && isEnabled === 0}>
              {time < 10 ? `0${time}` : time}:00
            </Button>
          );
        })}
      </div>
    </>
  );
};

export const SetConsultSession = (props: { asConsultant: boolean }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [data, setData] = useState<any>();
  const [mainLoading, setMainLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [daysOfWeek, setDaysOfWeek] = useState(
    eachDayOfInterval({
      start: new Date(),
      end: new Date(new Date().setDate(new Date().getDate() + 6))
    })
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedTimes, setSelectedTimes] = useState<any>({
    1: {},
    2: {},
    3: {},
    4: {},
    5: {},
    6: {},
    7: {}
  });
  const navigate = useNavigate();
  const { isUserRole } = useUser();
  const { id } = useParams();
  const [lastSelectedDay, setLastSelectedDay] = useState<number | null>(null);
  const [lastSelectedTime, setLastSelectedTime] = useState<number | null>(null);
  const [timeTableTimeStamp, setTimeTableTimeStamp] = useState(null);
  const [address, setAddress] = useState('');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedTime, setSelectedTime] = useState<any>();

  const isTimeEnabled = (d: number, t: number) => {
    const selectedTimesCopy = { ...selectedTimes };
    if (selectedTimesCopy[d][t] === 1) return 1;
    if (selectedTimesCopy[d][t] === 2) return 2;
    return 0;
  };

  const toggleSelectedTime = (d: number, t: number, isEnabled: number) => {
    const selectedTimesCopy = { ...selectedTimes };
    if (props.asConsultant) {
      if (isEnabled === 1) {
        selectedTimesCopy[d][t] = 0;
        setSelectedTimes(selectedTimesCopy);
      } else {
        selectedTimesCopy[d][t] = 1;
        setSelectedTimes(selectedTimesCopy);
      }
    } else {
      if (isEnabled === 2) {
        //
      } else if (isEnabled === 1) {
        setLastSelectedDay(d);
        setLastSelectedTime(t);

        for (const outerKey in selectedTimesCopy) {
          for (const innerKey in selectedTimesCopy[outerKey]) {
            if (selectedTimesCopy[outerKey][innerKey] === 2) {
              selectedTimesCopy[outerKey][innerKey] = 1;
            }
          }
        }
        selectedTimesCopy[d][t] = 2;
        setSelectedTimes(selectedTimesCopy);
      }
    }
    return false;
  };

  const handleSetSessionTimeByConsultant = useCallback(async () => {
    setLoading(true);
    const res = await handlePostSessionTimeByConsultant(
      parseInt(id ?? '-1'),
      JSON.stringify(selectedTimes).replaceAll('"', "'")
    );
    if (res.ok) {
      showToast('ساعات با موفقیت ثبت شد', 'success');
      navigate('/consultant/requests');
    }
    setLoading(false);
  }, [selectedTimes, id]);

  const handleSetSessionAddressByConsultant = useCallback(async () => {
    setLoading(true);
    // console.log(address);
    const res = await handlePutSessionTimeByConsultant(parseInt(id ?? '-1'), address);
    if (res.ok) {
      showToast('آدرس با موفقیت ثبت شد', 'success');
      navigate('/consultant/requests');
    }
    setLoading(false);
  }, [selectedTimes, id, address]);

  const handleSetSessionTimeByUser = useCallback(async () => {
    setLoading(true);
    const res = await handlePutSessionTimeByUser(
      parseInt(id ?? '-1'),
      JSON.stringify(selectedTimes).replaceAll('"', "'"),
      selectedTime
    );
    if (res.ok) {
      showToast('زمان انتخابی شما با موفقیت ثبت شد', 'success');
      navigate('/user/requests');
    }
    setLoading(false);
  }, [selectedTimes, id, selectedTime]);

  useEffect(() => {
    (async () => {
      setMainLoading(true);
      const res = await handleGetSession(parseInt(id ?? '-1'));
      if (res.ok) {
        setData(res.data);
        setMainLoading(false);
      }
      if (
        res.ok &&
        (res.data.Status === 'PendingUser' ||
          res.data.Status === 'PendingConsultant' ||
          res.data.Status === 'PendingMeeting')
      ) {
        setTimeTableTimeStamp(res.data.TimeTableTimeStamp);
        if (res.data.TimeTable) {
          setSelectedTimes(JSON.parse(res.data.TimeTable.replaceAll("'", '"')));
          setDaysOfWeek(
            eachDayOfInterval({
              start: new Date(res.data.TimeTableTimeStamp),
              end: new Date(new Date().setDate(new Date(res.data.TimeTableTimeStamp).getDate() + 6))
            })
          );
        }
      }
    })();
  }, [id]);

  useEffect(() => {
    if (timeTableTimeStamp && lastSelectedTime) {
      const theDate = new Date(
        new Date().setDate(new Date(timeTableTimeStamp).getDate() + (lastSelectedDay ?? 0) + -1)
      );

      theDate.setHours(lastSelectedTime);
      theDate.setMinutes(0);
      theDate.setSeconds(0);
      console.log(theDate);
      setSelectedTime(theDate);
      // console.log(format(theDate, 'dd MMMM yyyy hh:ss', { locale: faIR }));
      // console.log(
      //   parse(
      //     format(
      //       new Date(
      //         new Date().setDate(
      //           new Date(timeTableTimeStamp).getDate() + (lastSelectedDay ?? 0) + -1
      //         )
      //       ),
      //       'dd MMMM yyyy',
      //       { locale: faIR }
      //     ),
      //     'dd MMMM yyyy',
      //     new Date(),
      //     { locale: faIR }
      //   )
      // );
      // format(
      //   new Date(
      //     new Date().setDate(new Date(timeTableTimeStamp).getDate() + (lastSelectedDay ?? 0))
      //   ),
      //   'dd MMMM yyyy',
      //   { locale: faIR }
      // )
    }
  }, [timeTableTimeStamp, lastSelectedDay, lastSelectedTime]);

  const handleConsultMeetingDone = useCallback(async () => {
    setLoading(true);
    const res = await handlePatchSessionDoneByConsultant(parseInt(id ?? '-1'));
    if (res.ok) {
      showToast('زمان انتخابی شما با موفقیت ثبت شد', 'success');
      navigate(`/consultant/meeting-report/${id}`);
    }
    setLoading(false);
  }, [id]);

  if (mainLoading) {
    return <CustomLoader />;
  }
  return (
    <>
      {data.Status === 'PendingUser' && isUserRole('User') ? (
        <h4 className="text-h4">
          لطفا از بین زمان های فعال زیر یک زمان برای وقت مشاوره انتخاب کنید
        </h4>
      ) : null}
      {data.Status === 'PendingUser' && isUserRole('Consultant') ? (
        <h4 className="text-h4">در انتطار تایید و پرداخت یوزر، لطفا منتظر بمانید</h4>
      ) : null}
      {data.Status === 'PendingConsultant' && isUserRole('User') ? (
        <h4 className="text-h4">لطفا صبر کنید تا مشاور زمان های خالی خود را وارد کند</h4>
      ) : null}

      {data.Status === 'PendingConsultant' && isUserRole('Consultant') ? (
        <h4 className="text-h4">لطفا از بین زمان های زیر، زمان های خالی خود را انتخاب کنید</h4>
      ) : null}

      {data.Status === 'PendingMeeting' && isUserRole('Consultant') ? (
        <h4 className="text-h4">جزییات جلسه را وارد کنید</h4>
      ) : null}

      {data.Status === 'PendingDone' ? <h4 className="text-h4">جزییات جلسه</h4> : null}

      {data.Status === 'PendingUser' || data.Status === 'PendingConsultant' ? (
        <div className="flex justify-between mt-6" style={{ flexWrap: 'wrap' }}>
          {getArrayFilled(0, 7).map((daym1FromNow) => {
            const dayFromNow = daym1FromNow + 1;
            return (
              <TimeList
                key={dayFromNow}
                day={dayFromNow}
                isTimeEnabled={isTimeEnabled}
                toggleSelectedTime={toggleSelectedTime}
                viewMode={
                  (data.Status === 'PendingConsultant' && isUserRole('Consultant')) ||
                  (data.Status === 'PendingUser' && isUserRole('User'))
                    ? false
                    : true
                }
                daysOfWeek={daysOfWeek}
                asConsultant={props.asConsultant}
              />
            );
          })}
        </div>
      ) : null}

      {data && timeTableTimeStamp ? (
        <>
          {!lastSelectedTime ? null : (
            <>
              <Divider />
              <h4 className="text-center mt-4">
                {format(
                  new Date(
                    new Date().setDate(
                      new Date(timeTableTimeStamp).getDate() + (lastSelectedDay ?? 0) + -1
                    )
                  ),
                  'dd MMMM yyyy',
                  { locale: faIR }
                )}{' '}
                ساعت {lastSelectedTime}:00
              </h4>
              <Button
                appearance="primary"
                size="lg"
                className="mx-auto mt-4 ml-2 !block"
                onClick={handleSetSessionTimeByUser}
                loading={loading}>
                ثبت و پرداخت
              </Button>
            </>
          )}
        </>
      ) : null}
      {data ? (
        <>
          {data.Status === 'PendingConsultant' ? (
            <Button
              appearance="primary"
              className="mr-auto mt-4 ml-2 !block"
              onClick={handleSetSessionTimeByConsultant}
              loading={loading}>
              ثبت ساعات آزاد
            </Button>
          ) : null}

          <FlexboxGrid className="bg-[--rs-primary-50] border-[1px] border-[--rs-primary-300] rounded-md p-3  mt-5">
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%] mb-4">
              <h5 className="text-h5 mb-3 ">اطلاعات مشاوره</h5>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] mb-4">
              <strong> عنوان:</strong> {data.Topic}
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] mb-4">
              <strong> نوع مشاوره:</strong> {data.Type}
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] mb-4">
              <strong> دسته بندی: </strong> {data.Category}
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] mb-4">
              <strong> مدت مشاوره :</strong> {data.Category}
            </FlexboxGrid.Item>
            {data.SessionTimeStamp ? (
              <FlexboxGrid.Item
                as={Col}
                colspan={24}
                sm={24}
                md={8}
                className="max-w-[100%] mb-4 font-fd">
                <strong> تاریخ و زمان :</strong>{' '}
                {format(new Date(data.SessionTimeStamp), 'dd MMMM yyyy ساعت HH:mm', {
                  locale: faIR
                })}
              </FlexboxGrid.Item>
            ) : null}
            {data.Location ? (
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] mb-4">
                <strong> آدرس :</strong> {data.Location}
              </FlexboxGrid.Item>
            ) : null}
          </FlexboxGrid>
        </>
      ) : null}

      {data.Status === 'PendingMeeting' && isUserRole('Consultant') ? (
        <div className="mt-5">
          <br />
          آدرس جلسه اینترنتی یا حضوری را وارد کنید
          <Input value={address} onChange={setAddress} as="textarea" className="mt-1" />
          <Button
            appearance="primary"
            className="mr-auto mt-4 ml-2 !block"
            onClick={handleSetSessionAddressByConsultant}
            loading={loading}>
            افزودن آدرس
          </Button>
        </div>
      ) : null}

      {data.Status === 'PendingDone' && isUserRole('Consultant') ? (
        <Button
          appearance="primary"
          className="mr-auto mt-4 ml-2 !block"
          onClick={handleConsultMeetingDone}
          loading={loading}>
          جلسه پایان یافته؟
        </Button>
      ) : null}
    </>
  );
};
